var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Spinner } from 'shared/components/ui';
var LoadingOverlay = function (_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? true : _b, children = _a.children;
    return (_jsxs(Box, __assign({ rounded: "sm", opacity: enabled ? 0.9 : 1, pos: "relative", bgColor: enabled ? 'gray.300' : '' }, { children: [enabled && (_jsx(Spinner, { "data-testid": "loading", size: "lg", pos: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" })), children] })));
};
export { LoadingOverlay };
